var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#icon-appstore-a769a';
                    var viewUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#view-icon-appstore-a769a';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 120 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };